import {Component, HostListener, OnInit, ViewChildren} from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';
import { ShoppingCartService } from '../../services/shopping-cart-service';

@Component({
    selector: 'app-subheader',
    templateUrl: './subheader.component.html',
    styleUrls: ['./subheader.component.css', '../../../../assets/css/amena-theme.css'],
    standalone: false
})
export class SubheaderComponent implements OnInit {
    public monthly = 0;
    public initial = 0;
    public monthlyDiscount = 0;
    public total = 0;
    public title = '';
    @ViewChildren('navbar') navbar;
    @ViewChildren('filling') filling;

    constructor(private shoppingCartService: ShoppingCartService, public router: Router) {
        this.router.events.subscribe(
            (event) => {
                if (event instanceof NavigationEnd) {
                    let url = this.router.url;
                    this.changeSubTitle(url);
                }
            }
        );
    }

    ngOnInit(): void {
        this.shoppingCartService.monthlyTotalSubscription.subscribe(monthly => {
            this.monthly = monthly;
            this.setTotal();
        });

        this.shoppingCartService.initialTotalSubscription.subscribe(initial => {
            this.initial = initial;
            this.setTotal();
        });
        this.shoppingCartService.monthlyDiscountSubscription.subscribe(discount => {
            this.monthlyDiscount = discount;
            this.setTotal();
        });

        this.changeSubTitle(this.router.url);
    }

    setTotal() {
        if (this.router.url === '/amena/solo_movil') {
            this.total = this.monthly + this.initial;
        } else {
            this.total = (this.monthly - this.monthlyDiscount) + this.initial;
        }
    }

    openCart() {
        this.shoppingCartService.showCart();
    }

    changeSubTitle(url) {
        switch (url) {
            case '/amena/convergente':
                this.title = 'Contratación Fijo y Móvil';
                break;
            case '/amena/solo_movil':
                this.title = 'Contratación Móvil';
                break;
            case '/amena/listado':
                this.title = 'Listado de operaciones';
                break;
            default:
                this.title = '';
                break;
        }
    }

    cancel() {
        // this.shoppingCartService.clearShoppinCart();
        this.router.navigate(['/']);
    }

    @HostListener('window:scroll', ['$event'])
    doSomethingOnWindowScroll(event: Event) {
        const element: any = event.srcElement;
        const scrollOffset = element.children[0].scrollTop;
        const offsetTop = this.filling.first.nativeElement.offsetTop;

        if (scrollOffset >= offsetTop) {
            if (!this.navbar.first.nativeElement.classList.contains('fixed-top')) {
                this.filling.first.nativeElement.setAttribute('style', 'height: ' + this.navbar.first.nativeElement.offsetHeight + 'px');
                this.navbar.first.nativeElement.classList.add('fixed-top');
            }
        } else {
            if (this.navbar.first.nativeElement.classList.contains('fixed-top')) {
                this.filling.first.nativeElement.setAttribute('style', 'height: 0px');
                this.navbar.first.nativeElement.classList.remove('fixed-top');
            }
        }
    }
}
